import Route from 'cio/routes/base';
import FeaturesService from 'ember-feature-flags/services/features';
import { inject as service } from '@ember/service';

export interface ProductActivationRouteParams {
  product: string;
}

export default class ProductActivationRoute extends Route {
  @service features!: FeaturesService;

  model(params: ProductActivationRouteParams) {
    return params.product;
  }
}
